module.exports = __webpack_public_path__ + "static/media/ntt-logo.87bbb3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ntt-logo.png
// module id = 78
// module chunks = 0